var map = {
	"./svg/HTML5.svg": "../node_modules/platformicons/svg/HTML5.svg",
	"./svg/actix.svg": "../node_modules/platformicons/svg/actix.svg",
	"./svg/aiohttp.svg": "../node_modules/platformicons/svg/aiohttp.svg",
	"./svg/android.svg": "../node_modules/platformicons/svg/android.svg",
	"./svg/angularjs.svg": "../node_modules/platformicons/svg/angularjs.svg",
	"./svg/app-engine.svg": "../node_modules/platformicons/svg/app-engine.svg",
	"./svg/apple.svg": "../node_modules/platformicons/svg/apple.svg",
	"./svg/aws.svg": "../node_modules/platformicons/svg/aws.svg",
	"./svg/awslamda.svg": "../node_modules/platformicons/svg/awslamda.svg",
	"./svg/azure.svg": "../node_modules/platformicons/svg/azure.svg",
	"./svg/backbone.svg": "../node_modules/platformicons/svg/backbone.svg",
	"./svg/blazor.svg": "../node_modules/platformicons/svg/blazor.svg",
	"./svg/bootstrap.svg": "../node_modules/platformicons/svg/bootstrap.svg",
	"./svg/bottle.svg": "../node_modules/platformicons/svg/bottle.svg",
	"./svg/capacitor.svg": "../node_modules/platformicons/svg/capacitor.svg",
	"./svg/celery.svg": "../node_modules/platformicons/svg/celery.svg",
	"./svg/chalice.svg": "../node_modules/platformicons/svg/chalice.svg",
	"./svg/clojure.svg": "../node_modules/platformicons/svg/clojure.svg",
	"./svg/connect.svg": "../node_modules/platformicons/svg/connect.svg",
	"./svg/cordova.svg": "../node_modules/platformicons/svg/cordova.svg",
	"./svg/cryengine.svg": "../node_modules/platformicons/svg/cryengine.svg",
	"./svg/csharp.svg": "../node_modules/platformicons/svg/csharp.svg",
	"./svg/dart.svg": "../node_modules/platformicons/svg/dart.svg",
	"./svg/default.svg": "../node_modules/platformicons/svg/default.svg",
	"./svg/django.svg": "../node_modules/platformicons/svg/django.svg",
	"./svg/dotnet.svg": "../node_modules/platformicons/svg/dotnet.svg",
	"./svg/dotnetcore.svg": "../node_modules/platformicons/svg/dotnetcore.svg",
	"./svg/dotnetfx.svg": "../node_modules/platformicons/svg/dotnetfx.svg",
	"./svg/electron.svg": "../node_modules/platformicons/svg/electron.svg",
	"./svg/elixir.svg": "../node_modules/platformicons/svg/elixir.svg",
	"./svg/ember.svg": "../node_modules/platformicons/svg/ember.svg",
	"./svg/express.svg": "../node_modules/platformicons/svg/express.svg",
	"./svg/falcon.svg": "../node_modules/platformicons/svg/falcon.svg",
	"./svg/flask.svg": "../node_modules/platformicons/svg/flask.svg",
	"./svg/flutter.svg": "../node_modules/platformicons/svg/flutter.svg",
	"./svg/fsharp.svg": "../node_modules/platformicons/svg/fsharp.svg",
	"./svg/gatsby.svg": "../node_modules/platformicons/svg/gatsby.svg",
	"./svg/gcp.svg": "../node_modules/platformicons/svg/gcp.svg",
	"./svg/go.svg": "../node_modules/platformicons/svg/go.svg",
	"./svg/godot.svg": "../node_modules/platformicons/svg/godot.svg",
	"./svg/google.svg": "../node_modules/platformicons/svg/google.svg",
	"./svg/ionic.svg": "../node_modules/platformicons/svg/ionic.svg",
	"./svg/java.svg": "../node_modules/platformicons/svg/java.svg",
	"./svg/javascript.svg": "../node_modules/platformicons/svg/javascript.svg",
	"./svg/koa.svg": "../node_modules/platformicons/svg/koa.svg",
	"./svg/kotlin.svg": "../node_modules/platformicons/svg/kotlin.svg",
	"./svg/laravel.svg": "../node_modules/platformicons/svg/laravel.svg",
	"./svg/logback.svg": "../node_modules/platformicons/svg/logback.svg",
	"./svg/nativec.svg": "../node_modules/platformicons/svg/nativec.svg",
	"./svg/nextjs.svg": "../node_modules/platformicons/svg/nextjs.svg",
	"./svg/nodejs.svg": "../node_modules/platformicons/svg/nodejs.svg",
	"./svg/perl.svg": "../node_modules/platformicons/svg/perl.svg",
	"./svg/php.svg": "../node_modules/platformicons/svg/php.svg",
	"./svg/pyramid.svg": "../node_modules/platformicons/svg/pyramid.svg",
	"./svg/python.svg": "../node_modules/platformicons/svg/python.svg",
	"./svg/qt.svg": "../node_modules/platformicons/svg/qt.svg",
	"./svg/rails.svg": "../node_modules/platformicons/svg/rails.svg",
	"./svg/react.svg": "../node_modules/platformicons/svg/react.svg",
	"./svg/redis.svg": "../node_modules/platformicons/svg/redis.svg",
	"./svg/redux.svg": "../node_modules/platformicons/svg/redux.svg",
	"./svg/ruby.svg": "../node_modules/platformicons/svg/ruby.svg",
	"./svg/rust.svg": "../node_modules/platformicons/svg/rust.svg",
	"./svg/scala.svg": "../node_modules/platformicons/svg/scala.svg",
	"./svg/sentry.svg": "../node_modules/platformicons/svg/sentry.svg",
	"./svg/serverless.svg": "../node_modules/platformicons/svg/serverless.svg",
	"./svg/sinatra.svg": "../node_modules/platformicons/svg/sinatra.svg",
	"./svg/spring.svg": "../node_modules/platformicons/svg/spring.svg",
	"./svg/springboot.svg": "../node_modules/platformicons/svg/springboot.svg",
	"./svg/stride3d.svg": "../node_modules/platformicons/svg/stride3d.svg",
	"./svg/swift.svg": "../node_modules/platformicons/svg/swift.svg",
	"./svg/symfony.svg": "../node_modules/platformicons/svg/symfony.svg",
	"./svg/tornado.svg": "../node_modules/platformicons/svg/tornado.svg",
	"./svg/tryton.svg": "../node_modules/platformicons/svg/tryton.svg",
	"./svg/unity.svg": "../node_modules/platformicons/svg/unity.svg",
	"./svg/uno.svg": "../node_modules/platformicons/svg/uno.svg",
	"./svg/unreal.svg": "../node_modules/platformicons/svg/unreal.svg",
	"./svg/vue.svg": "../node_modules/platformicons/svg/vue.svg",
	"./svg/xamarin.svg": "../node_modules/platformicons/svg/xamarin.svg",
	"./svg_80x80/HTML5.svg": "../node_modules/platformicons/svg_80x80/HTML5.svg",
	"./svg_80x80/actix.svg": "../node_modules/platformicons/svg_80x80/actix.svg",
	"./svg_80x80/aiohttp.svg": "../node_modules/platformicons/svg_80x80/aiohttp.svg",
	"./svg_80x80/android.svg": "../node_modules/platformicons/svg_80x80/android.svg",
	"./svg_80x80/angularjs.svg": "../node_modules/platformicons/svg_80x80/angularjs.svg",
	"./svg_80x80/app-engine.svg": "../node_modules/platformicons/svg_80x80/app-engine.svg",
	"./svg_80x80/apple.svg": "../node_modules/platformicons/svg_80x80/apple.svg",
	"./svg_80x80/aws.svg": "../node_modules/platformicons/svg_80x80/aws.svg",
	"./svg_80x80/awslamda.svg": "../node_modules/platformicons/svg_80x80/awslamda.svg",
	"./svg_80x80/azure.svg": "../node_modules/platformicons/svg_80x80/azure.svg",
	"./svg_80x80/backbone.svg": "../node_modules/platformicons/svg_80x80/backbone.svg",
	"./svg_80x80/blazor.svg": "../node_modules/platformicons/svg_80x80/blazor.svg",
	"./svg_80x80/bootstrap.svg": "../node_modules/platformicons/svg_80x80/bootstrap.svg",
	"./svg_80x80/bottle.svg": "../node_modules/platformicons/svg_80x80/bottle.svg",
	"./svg_80x80/capacitor.svg": "../node_modules/platformicons/svg_80x80/capacitor.svg",
	"./svg_80x80/celery.svg": "../node_modules/platformicons/svg_80x80/celery.svg",
	"./svg_80x80/chalice.svg": "../node_modules/platformicons/svg_80x80/chalice.svg",
	"./svg_80x80/clojure.svg": "../node_modules/platformicons/svg_80x80/clojure.svg",
	"./svg_80x80/connect.svg": "../node_modules/platformicons/svg_80x80/connect.svg",
	"./svg_80x80/cordova.svg": "../node_modules/platformicons/svg_80x80/cordova.svg",
	"./svg_80x80/cryengine.svg": "../node_modules/platformicons/svg_80x80/cryengine.svg",
	"./svg_80x80/csharp.svg": "../node_modules/platformicons/svg_80x80/csharp.svg",
	"./svg_80x80/dart.svg": "../node_modules/platformicons/svg_80x80/dart.svg",
	"./svg_80x80/default.svg": "../node_modules/platformicons/svg_80x80/default.svg",
	"./svg_80x80/django.svg": "../node_modules/platformicons/svg_80x80/django.svg",
	"./svg_80x80/dotnet.svg": "../node_modules/platformicons/svg_80x80/dotnet.svg",
	"./svg_80x80/dotnetcore.svg": "../node_modules/platformicons/svg_80x80/dotnetcore.svg",
	"./svg_80x80/dotnetfx.svg": "../node_modules/platformicons/svg_80x80/dotnetfx.svg",
	"./svg_80x80/electron.svg": "../node_modules/platformicons/svg_80x80/electron.svg",
	"./svg_80x80/elixir.svg": "../node_modules/platformicons/svg_80x80/elixir.svg",
	"./svg_80x80/ember.svg": "../node_modules/platformicons/svg_80x80/ember.svg",
	"./svg_80x80/express.svg": "../node_modules/platformicons/svg_80x80/express.svg",
	"./svg_80x80/falcon.svg": "../node_modules/platformicons/svg_80x80/falcon.svg",
	"./svg_80x80/flask.svg": "../node_modules/platformicons/svg_80x80/flask.svg",
	"./svg_80x80/flutter.svg": "../node_modules/platformicons/svg_80x80/flutter.svg",
	"./svg_80x80/fsharp.svg": "../node_modules/platformicons/svg_80x80/fsharp.svg",
	"./svg_80x80/gatsby.svg": "../node_modules/platformicons/svg_80x80/gatsby.svg",
	"./svg_80x80/gcp.svg": "../node_modules/platformicons/svg_80x80/gcp.svg",
	"./svg_80x80/go.svg": "../node_modules/platformicons/svg_80x80/go.svg",
	"./svg_80x80/godot.svg": "../node_modules/platformicons/svg_80x80/godot.svg",
	"./svg_80x80/google.svg": "../node_modules/platformicons/svg_80x80/google.svg",
	"./svg_80x80/ionic.svg": "../node_modules/platformicons/svg_80x80/ionic.svg",
	"./svg_80x80/java.svg": "../node_modules/platformicons/svg_80x80/java.svg",
	"./svg_80x80/javascript.svg": "../node_modules/platformicons/svg_80x80/javascript.svg",
	"./svg_80x80/koa.svg": "../node_modules/platformicons/svg_80x80/koa.svg",
	"./svg_80x80/kotlin.svg": "../node_modules/platformicons/svg_80x80/kotlin.svg",
	"./svg_80x80/laravel.svg": "../node_modules/platformicons/svg_80x80/laravel.svg",
	"./svg_80x80/logback.svg": "../node_modules/platformicons/svg_80x80/logback.svg",
	"./svg_80x80/nativec.svg": "../node_modules/platformicons/svg_80x80/nativec.svg",
	"./svg_80x80/nextjs.svg": "../node_modules/platformicons/svg_80x80/nextjs.svg",
	"./svg_80x80/nodejs.svg": "../node_modules/platformicons/svg_80x80/nodejs.svg",
	"./svg_80x80/perl.svg": "../node_modules/platformicons/svg_80x80/perl.svg",
	"./svg_80x80/php.svg": "../node_modules/platformicons/svg_80x80/php.svg",
	"./svg_80x80/pyramid.svg": "../node_modules/platformicons/svg_80x80/pyramid.svg",
	"./svg_80x80/python.svg": "../node_modules/platformicons/svg_80x80/python.svg",
	"./svg_80x80/qt.svg": "../node_modules/platformicons/svg_80x80/qt.svg",
	"./svg_80x80/rails.svg": "../node_modules/platformicons/svg_80x80/rails.svg",
	"./svg_80x80/react.svg": "../node_modules/platformicons/svg_80x80/react.svg",
	"./svg_80x80/redis.svg": "../node_modules/platformicons/svg_80x80/redis.svg",
	"./svg_80x80/redux.svg": "../node_modules/platformicons/svg_80x80/redux.svg",
	"./svg_80x80/ruby.svg": "../node_modules/platformicons/svg_80x80/ruby.svg",
	"./svg_80x80/rust.svg": "../node_modules/platformicons/svg_80x80/rust.svg",
	"./svg_80x80/scala.svg": "../node_modules/platformicons/svg_80x80/scala.svg",
	"./svg_80x80/sentry.svg": "../node_modules/platformicons/svg_80x80/sentry.svg",
	"./svg_80x80/serverless.svg": "../node_modules/platformicons/svg_80x80/serverless.svg",
	"./svg_80x80/sinatra.svg": "../node_modules/platformicons/svg_80x80/sinatra.svg",
	"./svg_80x80/spring.svg": "../node_modules/platformicons/svg_80x80/spring.svg",
	"./svg_80x80/springboot.svg": "../node_modules/platformicons/svg_80x80/springboot.svg",
	"./svg_80x80/stride3d.svg": "../node_modules/platformicons/svg_80x80/stride3d.svg",
	"./svg_80x80/swift.svg": "../node_modules/platformicons/svg_80x80/swift.svg",
	"./svg_80x80/symfony.svg": "../node_modules/platformicons/svg_80x80/symfony.svg",
	"./svg_80x80/tornado.svg": "../node_modules/platformicons/svg_80x80/tornado.svg",
	"./svg_80x80/tryton.svg": "../node_modules/platformicons/svg_80x80/tryton.svg",
	"./svg_80x80/unity.svg": "../node_modules/platformicons/svg_80x80/unity.svg",
	"./svg_80x80/uno.svg": "../node_modules/platformicons/svg_80x80/uno.svg",
	"./svg_80x80/unreal.svg": "../node_modules/platformicons/svg_80x80/unreal.svg",
	"./svg_80x80/vue.svg": "../node_modules/platformicons/svg_80x80/vue.svg",
	"./svg_80x80/xamarin.svg": "../node_modules/platformicons/svg_80x80/xamarin.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../node_modules/platformicons sync recursive ^\\.\\/.*\\.svg$";